import React, { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import { ExportViewProps, ExportViewRef } from "./models";
import SearchFilter, { Filters } from "../../../Common/SearchFilter/SearchFilter";
import { searchFilterToExportExcelFilter } from "../../../Common/SearchFilter/utils";
import useDidMountEffect from "../../../Common/UseDidMountEffect";
import { ApiBackend } from "../../../../providers/apibackend";
import { Event } from "../../../../model/Event";
import { Product } from "../../../../model/Product";

type SearchFilterType = {
    raceWeek?: string;
    product?: string;
    onlyFinished?: boolean;
};

interface ISearchFilter {
    raceWeek?: string;
    product?: string;
    onlyFinished?: boolean;
}

const MedalHemmavasan = forwardRef<ExportViewRef, ExportViewProps>((props, ref) => {
    const [searchFilter, setSearchFilter] = useState(null as ISearchFilter);
    const [events, setEvents] = useState(null as Event[]);
    const [products, setProducts] = useState(null as Product[]);

    useImperativeHandle(ref, () => ({
        isValid: () => {
            return !!searchFilter?.raceWeek && !!searchFilter?.product;
        }
    }));

    useEffect(() => {
        const backend = new ApiBackend();
        backend.listEvents().then(setEvents);
        backend.listProducts().then(setProducts);
    }, []);

    useDidMountEffect(() => {
        props.onChange(searchFilterToExportExcelFilter<ISearchFilter>(searchFilter));
    }, [searchFilter]);

    const render = () => {
        const eventProducts = products
            ?.filter(x => searchFilter?.raceWeek && x.EventId === searchFilter.raceWeek)
            .slice()
            .sort((a, b) => (a.name || "").localeCompare(b.name || "", "sv"));
        return (
            <SearchFilter<SearchFilterType>
                id={"export-medalhemmavasan-filter"}
                filters={{
                    "raceWeek": {
                        id: "filter-raceWeek",
                        type: "GenericSelect",
                        label: "Evenemang",
                        size: 12,
                        multiple: false,
                        itemDefinition: {
                            items: events == null ? [] : events.map(x => { return { name: x.name, value: x.id } }),
                            itemValueType: "string"
                        }
                    },
                    "product": {
                        id: "filter-product",
                        type: "GenericSelect",
                        label: "Produkt",
                        size: 12,
                        multiple: false,
                        itemDefinition: {
                            items: eventProducts == null ? [] : eventProducts.map(x => { return { name: x.name + '', value: x.id } }),
                            itemValueType: "string"
                        }
                    },
                    "onlyFinished": {
                        id: "filter-onlyfinished",
                        type: "Checkbox",
                        label: "Endast fullföljda (status FNS)",
                        size: 12,
                    },
                }}
                persist={true}
                onInit={(filter: Filters<SearchFilterType>) => {
                    setSearchFilter(filter as unknown as ISearchFilter);
                }}
                onChange={(filter: Filters<SearchFilterType>) => {
                    setSearchFilter(filter as unknown as ISearchFilter);
                }}
            />
        );
    };

    return render();
});

export default MedalHemmavasan;
